import type { TRiskRankWithNA } from "./Risk";


export const HarmCategories = ["financial", "reputational", "operational", "legal_regulatory"] as const;
export type THarmCategory = (typeof HarmCategories)[number];


export function harmCategoryToLabel(category: THarmCategory): string {
    switch (category) {
        case "financial": return "Financial";
        case "reputational": return "Reputational";
        case "operational": return "Operational";
        case "legal_regulatory": return "Legal and Regulatory";
        default: return category;

    }
}

const OWNER_LABELS: Record<string, string> = {
    data_privacy: "Data and Privacy (CDO / DPO)",
    legal_compliance: "Legal and Compliance",
    ai_technical_lead: "AI Technical Lead",
    ai_governance_lead: "AI Governance Lead",
    information_security: "Information Security",
    business_owner: "Business Owner",
    risk_management: "Risk Management",
    technology_it: "Technology and IT",
};

export function accountableOwnerToLabel(owner: string): string {
    return OWNER_LABELS[owner] ?? owner;
}

export class Harm {
    harmRank: TRiskRankWithNA = "n/a";
    description: string = "";

    constructor(init?: Partial<Harm>) {
        Object.assign(this, init);
    }

}





